<div
  class="vertical-timeline-icon white-bg"
  ng-class="[$ctrl.aplicacao.extraInfo.border]"
  uib-tooltip="{{$ctrl.aplicacao.extraInfo.title}}"
  tooltip-append-to-body="true"
  tooltip-placement="bottom"
>
  <i
    ng-class="[
      'fa', $ctrl.aplicacao.extraInfo.icon, $ctrl.aplicacao.extraInfo.color
    ]"
  ></i>
</div>
<form name="form" class="vertical-timeline-content" novalidate>
  <div class="row">
    <h3 class="col-xs-6">
      <span ng-if="$ctrl.aplicacao.status !== 'will_not_perform'">{{$ctrl.aplicacao.id ? $ctrl.aplicacao.numero_aplicacao + 'ª' : 'Nova'}} Aplicação</span>
      <s ng-if="$ctrl.aplicacao.status === 'will_not_perform'">{{::$ctrl.aplicacao.numero_aplicacao}}ª Aplicação</s>
    </h3>
    <div
      class="col-xs-6 text-right"
      ng-if="$root.permissions.recomendacao.canManage"
    >
      <button
        type="button"
        class="btn-xs btn-link"
        ng-if="$ctrl.canEdit()"
        uib-tooltip="Editar"
        tooltip-append-to-body="true"
        ng-click="$ctrl.isEditing = true"
      >
        <i class="fa fa-edit"></i>
      </button>
      <button
        type="button"
        class="btn-xs btn-link"
        ng-if="$ctrl.canDisablePerforming()"
        uib-tooltip="Não será aplicada"
        tooltip-append-to-body="true"
        ng-click="$ctrl.willNotPerform()"
      >
        <i class="fa fa-times"></i>
      </button>
      <button
        type="button"
        class="btn-xs btn-link"
        ng-if="$ctrl.canEnablePerforming()"
        uib-tooltip="Será aplicada"
        tooltip-append-to-body="true"
        ng-click="$ctrl.willPerform()"
      >
        <i class="fa fa-calendar"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-6">
      <p ng-hide="$ctrl.isEditing">
        Data estimada: {{$ctrl.aplicacao.data_estimada | date: 'dd/MM'}}
      </p>
      <div
        class="form-group"
        ng-class="{ 'has-error': form.dataEstimada.$invalid && form.dataEstimada.$dirty }"
        ng-if="$ctrl.isEditing"
      >
        <label for="dataEstimada">Data estimada</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            readonly
            datepicker-options="$ctrl.datepickerOptions"
            placeholder="Data"
            uib-datepicker-popup="dd/MM/yyyy"
            ng-model="$ctrl.editAplicacao.data_estimada"
            id="dataEstimada"
            name="dataEstimada"
            required
            is-open="$ctrl.datepickerPlantio.open"
            show-button-bar="false"
            datepicker-append-to-body="true"
            min-date="$ctrl.datepickerMinDate"
          >
          <span class="input-group-btn">
            <button
              type="button"
              class="btn btn-default"
              ng-click="$ctrl.datepickerPlantio.open = !$ctrl.datepickerPlantio.open"
              ng-disabled="$ctrl.working"
            >
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
      </div>
      <div ng-if="$ctrl.aplicacao.status === 'applied'">
        <p ng-class="{ 'text-emergencia': $ctrl.wasAppliedLate() }">
          Data efetiva: {{$ctrl.aplicacao.data_fim_aplicacao | date: 'dd/MM'}}
          <i
            class="fa fa-exclamation-triangle"
            ng-if="$ctrl.wasAppliedLate()"
            uib-tooltip="Aplicada após a data estimada"
            tooltip-append-to-body="true"
            tooltip-placement="right"
          ></i>
        </p>
        <p>
          Dias após aplicado: {{$ctrl.aplicacao.dias_apos_aplicado}}
        </p>       
      </div>
    </div>
    <div class="col-xs-6" ng-hide="$ctrl.isEditing">
      <p><b>Observações</b></p>
      <p>{{$ctrl.aplicacao.observacoes}}</p>
    </div>
    <div class="col-xs-6" ng-if="$ctrl.isEditing">
      <div
        class="form-group"
        ng-class="{ 'has-error': form.observacoes.$invalid && form.observacoes.$dirty }"
      >
        <label for="observacoes" class="control-label">Observações</label>
        <textarea
          name="observacoes"
          id="observacoes"
          class="form-control"
          ng-model="$ctrl.editAplicacao.observacoes"
          ng-disabled="$ctrl.working"
        ></textarea>
      </div>
    </div>
    <div class="col-xs-12" ng-show="!!$ctrl.aplicacao.diasEntreEmergenciaEAplicacao">
      <p>Nº de dias após emergência: {{$ctrl.aplicacao.diasEntreEmergenciaEAplicacao}}</p>
    </div>
    <div class="col-xs-12" ng-hide="$ctrl.isEditing">
      <table class="table table-striped" ng-if="$ctrl.aplicacao.items.length > 0">
        <thead>
          <tr>
            <th>Produto</th>
            <th>Dose</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="produto in $ctrl.aplicacao.items track by produto.id">
            <td>{{produto.item_estoque.descricao}}</td>
            <td>{{produto.dose | number:3}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}/ha</td>
            <td>{{produto.dose * (+$ctrl.aplicacao.area || $ctrl.cronograma.gleba.area_total) | number:2}} {{$ctrl.fixAbreviatura(produto.unidade.abreviatura)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-xs-12" ng-if="$ctrl.isEditing">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Produto</th>
            <th>Dose</th>
            <th colspan="2">Unidade</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="produto in $ctrl.editAplicacao.items_attributes track by produto.item_id">
            <td>{{produto.item.descricao}}</td>
            <td class="field-dose">
              <div class="form-group">
                <input
                  type="number"
                  ng-model="produto.dose"
                  min="0.0001"
                  placeholder="Dose"
                  required
                  class="form-control"
                  ng-disabled="$ctrl.working"
                >
              </div>
            </td>
            <td class="field-unidade">
              <div class="form-group">
                <select
                  ng-model="produto.unidade"
                  ng-options="unidade.abreviatura for unidade in produto.unidades track by unidade.id"
                  ng-change="$ctrl.updateUnidade(produto, $event)"
                  required
                  class="form-control"
                  ng-disabled="$ctrl.working"
                ></select>
              </div>
            </td>
            <td>
              <button
                type="button"
                class="btn-xs btn-link text-danger"
                uib-tooltip="Remover item"
                tooltip-append-to-body="true"
                ng-disabled="$ctrl.working"
                ng-click="$ctrl.removeItem(produto)"
              >
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3">
              <div class="form-group no-margin">
                <ui-select 
                  ng-model="$ctrl.newItem"
                  on-select="$ctrl.addItem()"
                  theme="bootstrap" 
                  id="produtos" 
                  name="produtos" 
                  ng-disabled="$ctrl.working">

                  <ui-select-match allow-clear="$ctrl.canEdit()" placeholder="Pesquisar produto">
                    {{$select.selected.descricao}}
                  </ui-select-match>
                  <ui-select-choices 
                    repeat="produto in $ctrl.items" 
                    refresh="$ctrl.searchItems($select)"
                    ng-disabled="$ctrl.working"
                    refresh-delay="300" >

                    <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
                    <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
                      <small ng-bind-html="'Físico: ' + (produto.saldo_fisico | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
                      <small ng-bind-html="'Em Uso: ' + (produto.saldo_em_uso | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
                      <small ng-bind-html="'A Receber: ' + (produto.saldo_receber | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
                    </span>
                  </ui-select-choices>
                </ui-select>
                <small class="help-block" ng-show="$ctrl.searchItem.length && !$ctrl.loadingItems && !$ctrl.items">
                  Informe pelo menos 3 caracteres
                </small>
                <span class="input-group-addon no-border no-background" ng-show="!$ctrl.loadingItems && $ctrl.items.length === 0">
                  Não encontrado
                </span>

              </div>
            </td>
            <td>    
              <i class="fa fa-spinner fa-spin m-t-sm" ng-show="$ctrl.loadingItems"></i>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <div class="text-right" ng-if="$ctrl.isEditing">
    <button
      type="submit"
      class="btn btn-primary"
      ng-click="$ctrl.saveChanges()"
      ng-disabled="form.$invalid || $ctrl.working"
    >
      Salvar
    </button>
    <button
      type="button"
      class="btn btn-link"
      ng-click="$ctrl.cancelChanges()"
      ng-disabled="$ctrl.working"
    >
      Cancelar
    </button>
  </div>
</form>
